import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import LoginForm from "../../components/auth/LoginForm";
import Logo from "../../../resources/images/academyFinalBlue.png";
import { alertNotification } from "../../../utils/alerts";

// FOC-488 — Textos de los códigos de sesión que onSessionError pasa como
// ?motivo=CODE después de limpiar storage. Si el param queda sin ser leído,
// el guard de onSessionError bloquea redirects posteriores, así que SIEMPRE
// hay que mostrarlo y limpiarlo.
const MOTIVO_MESSAGES = {
  SESSION_REVOKED:
    "Tu sesión se cerró porque se cambió la contraseña. Inicia sesión de nuevo.",
  DEVICE_MISMATCH: "Tu sesión terminó. Inicia sesión de nuevo.",
  APPLICATION_MISMATCH: "Tu sesión terminó. Inicia sesión de nuevo.",
  DPOP_PROOF_INVALID: "Tu sesión terminó. Inicia sesión de nuevo.",
  TOKEN_INVALID: "Tu sesión terminó. Inicia sesión de nuevo.",
};

/**
 * Página /login — wrapper de pantalla completa para el <LoginForm>
 * reutilizable. El mismo formulario vive también dentro del ModalHome
 * (evitando navegar cuando el usuario ya está en la home). Toda la
 * lógica de autenticación (POST user/authentication, cookies, redirect)
 * vive en `<LoginForm>`; esta pantalla es solo el chrome.
 */
const Login = () => {
  const { t } = useTranslation("global");

  // Lee el ?motivo= que onSessionError (axios-dpop) deja al redirigir,
  // muestra el toast descriptivo y limpia el param. Si no limpiamos acá
  // el guard de onSessionError queda trabado (no re-redirige mientras
  // ?motivo= siga en la URL).
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const motivo = params.get("motivo");
    if (!motivo) return;
    const message = MOTIVO_MESSAGES[motivo];
    if (message) alertNotification(message);
    params.delete("motivo");
    const query = params.toString();
    const url =
      window.location.pathname + (query ? `?${query}` : "") + window.location.hash;
    window.history.replaceState(null, "", url);
  }, []);

  return (
    <main
      className="page-content"
      style={{
        background: "var(--color-bg)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 16px",
      }}
    >
      <div style={{ width: "100%", maxWidth: 460 }}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <img
            src={Logo}
            alt="Academy by VisionBiz"
            style={{ height: 44, width: "auto", display: "inline-block" }}
          />
        </div>

        <section
          className="bg-surface"
          style={{
            border: "1px solid var(--color-line)",
            borderRadius: 16,
            padding: "28px 24px 24px",
            boxShadow: "0 8px 24px rgba(16, 28, 54, 0.06)",
          }}
        >
          <h1
            style={{
              fontSize: 26,
              lineHeight: 1.2,
              fontWeight: 800,
              letterSpacing: "-.02em",
              margin: "0 0 6px",
            }}
          >
            {t("login.pageTitle")}
          </h1>
          <p
            className="text-ink-2"
            style={{
              fontSize: 15,
              lineHeight: 1.55,
              fontWeight: 600,
              margin: "0 0 22px",
            }}
          >
            {t("login.message")}
          </p>

          <LoginForm />
        </section>
      </div>
    </main>
  );
};

export default Login;
